module.exports = __webpack_public_path__ + "static/media/codereview.a270a386.png";